import { string, shape, object } from 'prop-types'
import { Container } from '@mch-group/uikit-components'
import Link from 'next/link'
import dayjs from 'dayjs'

import { date } from '@constants'
import { formatHour, getDatesExhibition, getLocationMapLink, getTimeZone } from '@utils'
import { Text } from '@components'
import { Icon } from '@mch-group/uikit-components'

const EventDetailInfos = ({
  data,
  globalLabels,
  organizedByLabel,
  recommendedByLabel,
  openingTime,
  translatedExhibitionOpeningHours,
  language,
  ...props
}) => (
  <Container className='mb-10'>
    <Container className={containerFirst}>
      <div>
        <Icon name='calendar' color='var(--bs-mch-gray-500)' />
      </div>
      {!data.exhibition && openingTime && (
        <div>
          <Text isSmall>{dayjs(openingTime.date).format(date.FE_WEEK_DATE_FORMAT)}</Text>
        </div>
      )}
      {data.exhibition && data.startDate && (
        <div>
          <Text isSmall>{getDatesExhibition(data.startDate, data.endDate)}</Text>
        </div>
      )}
    </Container>

    {!data.exhibition && (
      <Container className={containerOther}>
        <div>
          <Icon name='time' color='var(--bs-mch-gray-500)' />
        </div>
        <div>
          <Text isSmall>
            {openingTime && <span>{formatHour(openingTime.startTime, 'hh:mm', globalLabels)}</span>}
            {openingTime && openingTime.endTime ? (
              <>
                <span>&nbsp;-&nbsp;</span>
                <span>{formatHour(openingTime.endTime, 'hh:mm', globalLabels)}</span>
              </>
            ) : (
              <>
                <span>&nbsp;-&nbsp;</span>
                <span>{globalLabels.las_grp1_onwards || 'onwards'}</span>
              </>
            )}
            {data.timezoneId && data.startDateTimeIso8601 && <span>&nbsp;{`${getTimeZone(data.startDateTimeIso8601, data.timezoneId)}`}</span>}
          </Text>
        </div>
      </Container>
    )}

    {data.exhibition && data.exhibitionOpeningHours && (
      <Container className={containerOther}>
        <div>
          <Icon name='time' color='var(--bs-mch-gray-500)' />
        </div>
        <div>
          <Text isSmall>
            <span>{language == 'en' ? data.exhibitionOpeningHours : translatedExhibitionOpeningHours}</span>
          </Text>
        </div>
      </Container>
    )}

    <Container className={containerOther}>
      <div>
        <Icon name='pin' color='var(--bs-mch-gray-500)' />
      </div>
      {data.onlineShowId && <Container>{props.OnlineStatus}</Container>}
      <div>
        {data.virtual && (
          <>
            <Text isSmall>{props.onlineLocationLabel}</Text>
            <a className='virtual-url-link' href={data.virtualUrl} target='_blank' rel='nofollow noopener'>
              <strong> {data.virtualUrl}</strong>
            </a>
          </>
        )}
        {data.venue && !data.hideVenue && (
          <Link href={getLocationMapLink({ venue: data.venue, hall: data.hall })} legacyBehavior>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            <a target='_blank'>
              {[
                data.venue.name,
                data.hall,
                data.venue.street,
                data.venue.street2,
                data.venue.city,
                data.venue.country && [data.venue.postCode, data.venue.country].filter(Boolean).join(', ')
              ]
                .filter(Boolean)
                .map((item, index) => (
                  <Text key={`${item}-${index}`} isSmall className='location-detail'>
                    {item}
                  </Text>
                ))}
            </a>
          </Link>
        )}
      </div>
    </Container>
    {data.additionalInfoUrl && (
      <Container className={containerOther}>
        <div>
          <Icon name='add-info' color='var(--bs-mch-gray-500)' />
        </div>
        <div>
          <a className='additional-info-link' href={data.additionalInfoUrl} target='_blank' rel='noreferrer noopener'>
            <Text isSmall>{props.additionalInformationLabel}</Text>
          </a>
        </div>
      </Container>
    )}
    {(data.organiser || data.recommender) && (
      <Container className={containerOther}>
        <div>
          <Icon name='gallery' color='var(--bs-mch-gray-500)' />
        </div>
        <div>
          {data.organiser && (
            <Text forwardedAs='div' isSmall>
              {`${organizedByLabel || 'Organized by'} `}
              <strong>{data.organiser.organiser}</strong>
            </Text>
          )}
          {data.recommender && (
            <Text forwardedAs='div' isSmall>
              {`${recommendedByLabel || 'Recommended by'} `}
              <strong>{data.recommender}</strong>
            </Text>
          )}
        </div>
      </Container>
    )}
  </Container>
)

const containerFirst = 'gap-4 d-flex'
const containerOther = 'gap-4 d-flex mt-6'

EventDetailInfos.propTypes = {
  data: object,
  organizedByLabel: string,
  recommendedByLabel: string,
  OnlineStatus: string,
  onlineLocationLabel: string,
  additionalInformationLabel: string,
  openingTime: object,
  globalLabels: shape({
    las_grp1_onwards: string
  }),
  translatedExhibitionOpeningHours: string,
  language: string
}

export default EventDetailInfos
